
import { useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { GameVoteTeamNotFound } from "@/components/game-vote/game-vote-team-not-found";
import { VanityUrlLoading } from "@/components/game-vote/vanity-url-loading";
import { useVanityRedirect } from "@/hooks/use-vanity-redirect";

const VanityUrlRedirect = () => {
  const navigate = useNavigate();
  const params = useParams();
  
  const { 
    isLoading, 
    error, 
    teamDisplayName, 
    teamFound,
    shouldShowPWAPrompt 
  } = useVanityRedirect();
  
  useEffect(() => {
    console.log("VanityUrlRedirect - Debug Info:", {
      component: "VanityUrlRedirect",
      params,
      currentPath: window.location.pathname,
      fullUrl: window.location.href,
      urlSlug: params.urlSlug,
      teamName: params.teamName,
      clubAcronym: params.clubAcronym
    });
  }, [params]);
  
  const handleBackClick = () => {
    console.log("VanityUrlRedirect - Back button clicked, navigating to home");
    navigate("/");
  };
  
  if (isLoading) {
    console.log("VanityUrlRedirect - Showing loading state");
    return <VanityUrlLoading />;
  }
  
  if (error) {
    console.log("VanityUrlRedirect - Showing error state:", {
      error,
      teamDisplayName,
      teamFound,
      shouldShowPWAPrompt
    });
    
    return (
      <GameVoteTeamNotFound 
        error={error}
        teamName={teamDisplayName}
        teamFound={teamFound}
        onBackClick={handleBackClick}
        showPWAPrompt={shouldShowPWAPrompt}
      />
    );
  }
  
  // This should never be reached because we either redirect to a game
  // or show an error if no games are found
  console.log("VanityUrlRedirect - End of component reached without redirect or error");
  return null;
};

export default VanityUrlRedirect;
